import React, { Component } from 'react';
import { Tabs, Tab, Grid, Cell, Card, CardTitle, CardText, CardMenu,} from 'react-mdl';


class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }

  toggleCategories() {

    if(this.state.activeTab === 0){
      return(
        <div>
        <div className="banner-text">
        <h1 style={{textAlign: 'center', fontSize: '360%'}}>AstroChat</h1>
      <hr></hr>
      <div>
      <p>•	Engaged in the use of Web2py, Python, and HTML/CSS.</p>
      <p>•	Focused on crafting visual elements of the website and also the forum which allowed people to post about their astrology signs.</p>
      <p>•	Created using Web2py on a team of four, and received a very high grade in the class.</p>
      <p class="double-spaced">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;URL: <a href = {"https://dbuccat.pythonanywhere.com/astrochat"} rel="noopener noreferrer" target = {"_blank"} className = "SocialHeading" style ={{textDecoration: 'none'}}> https://dbuccat.pythonanywhere.com/astrochat </a>
      <a href="https://dbuccat.pythonanywhere.com/astrochat" rel="noopener noreferrer" target="_blank" className="project-social">
           <i  className="fa fa-external-link" aria-hidden="true" /></a> <br /> &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Github:&ensp;
       <a href="https://github.com/donovanbuccat/cmps_183" rel="noopener noreferrer" target="_blank" className="project-social">
            <i  className="fa fa-github-square" aria-hidden="true" />
            </a> </p>
      </div>
      </div>

                    {/* <img
              src="./AstroChat-LandingPage.png"
              style={{ maxHeight: '20%', maxWidth: '30%', minHeight: '40%', minWidth: '19%', marginBottom: '2%'}}
              {{minWidth: '450', margin: 'auto'}}>
              alt="avatar" 960 540
              className="avatar-img"
              style={{color: '#000000', textAlign: 'center',}}
              /> */}

          <Grid className = "SocialHeading">
          <Card shadow={5} style={{minWidth: '85%', margin: 'auto'}}>
          <CardText>
            </CardText>
          <CardText style={{color: '#000000', textAlign: 'center', fontSize: '197%', fontWeight: 'bold'}}>
              AstroChat Landing Page
            </CardText>
            <CardText>
            </CardText>
            <CardTitle style={{color: '#fff', height: '680px', background: 'url(./AstroChat-LandingPage.png) center / cover', backgroundSize: '100% 100%'}} ></CardTitle>
            </Card>

            <Card shadow={5} style={{minWidth: '85%', margin: 'auto'}}>
            <CardText>
            </CardText>
            <CardText style={{color: '#000000', textAlign: 'center', fontSize: '197%', fontWeight: 'bold'}}>
              AstroChat Profile Page
            </CardText>
            <CardText>
            </CardText>
            <CardTitle style={{color: '#fff', height: '680px', background: 'url(./AstroChat-Profile.png) center / cover', backgroundSize: '100% 100%'}} ></CardTitle>
            </Card>


            {/* <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(./AstroChat-Forum.png) center / cover'}} ></CardTitle>
            <CardText style={{color: '#000000', textAlign: 'center'}}>
              AstroChat Forum
            </CardText>
          </Card> */}

        </Grid>
        <div className="banner-text SocialHeading">
        <br></br>
        <br></br>
        <br></br>
          <br></br>
        <p class="double-spaced">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;URL: <a href = {"https://dbuccat.pythonanywhere.com/astrochat"} rel="noopener noreferrer" target = {"_blank"} > https://dbuccat.pythonanywhere.com/astrochat </a> <br /> &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Github:&ensp;
       <a href="https://github.com/donovanbuccat/cmps_183" rel="noopener noreferrer" target="_blank" className="project-social">
            <i  className="fa fa-github-square" aria-hidden="true" />
            </a> </p>
            <br></br>
            <br></br>
            <br></br>
            </div>
      </div>

      )
    } else if(this.state.activeTab === 1) {
      return (
        <div className="banner-text">
      <h1 style={{textAlign: 'center', fontSize: '360%'}}>Portfolio Website</h1>
      <hr></hr>
      <div>
      <p>•	Engaged in the use of React, JavaScript, and AWS.</p>
      <p>•	Designed the website to display my previous web and mobile applications.</p>
      <p>•	Created with React to exhibit projects in a meaningful way. </p>
      <div>
      <center>
      <p>URL: <a href = {"http://donovanbuccat.com"} rel="noopener noreferrer" target = {"_blank"}> http://donovanbuccat.com</a></p>
      </center>
      <div>
      <p></p>
      </div>
      </div>
      </div>
      </div>

      )
    } else if(this.state.activeTab === 2) {
      return (
        <div className="banner-text">
        <h1 style={{textAlign: 'center', fontSize: '360%'}}>Better Quiz App</h1>
        <hr></hr>
        <div>
        <p>•	Engaged in the use of Django, Python, and HTML/CSS.</p>
        <p>•	Focused on crafting visual elements of the website and also the quiz details which displays the quiz questions.</p>
        <p>•	Created using Django, and received a very high grade in the class.</p>
        <p class="double-spaced">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;URL: <a href = {"http://donovanbuccat.pythonanywhere.com"} rel="noopener noreferrer" target = {"_blank"} className = "SocialHeading" style ={{textDecoration: 'none'}}> http://donovanbuccat.pythonanywhere.com </a>
        <a href="http://donovanbuccat.pythonanywhere.com" rel="noopener noreferrer" target="_blank" className="project-social" >
            <i  className="fa fa-external-link" aria-hidden="true"/></a>
         &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Github:&ensp;
       <a href="https://github.com/donovanbuccat/CS115-Better-Quiz-App" rel="noopener noreferrer" target="_blank" className="project-social">
            <i  className="fa fa-github-square" aria-hidden="true" />
            </a> </p>
        </div>

        {/* <Card shadow={5} style={{minWidth: '100%', margin: 'auto'}}>
            <CardText>
            </CardText>
            <CardText style={{color: '#000000', textAlign: 'center', fontSize: '197%', fontWeight: 'bold'}}>
              Better Quiz App Dashboard
            </CardText>
            <CardText>
            </CardText>
            <CardTitle style={{color: '#fff', height: '640px', background: 'url(./BetterQuizApp-Dashboard.png) center / cover'}} ></CardTitle>
            </Card>

            <Card shadow={5} style={{minWidth: '100%', margin: 'auto'}}>
            <CardText>
            </CardText>
            <CardText style={{color: '#000000', textAlign: 'center', fontSize: '197%', fontWeight: 'bold'}}>
               Better Quiz App Quiz
            </CardText>
            <CardText>
            </CardText>
            <CardTitle style={{color: '#fff', height: '640px', background: 'url(./BetterQuizApp-Quiz.png) center / cover'}} ></CardTitle>
            </Card>

            <Card shadow={5} style={{minWidth: '100%', margin: 'auto'}}>
            <CardText>
            </CardText>
            <CardText style={{color: '#000000', textAlign: 'center', fontSize: '197%', fontWeight: 'bold'}}>
              Better Quiz App Results
            </CardText>
            <CardText>
            </CardText>
            <CardTitle style={{color: '#fff', height: '640px', background: 'url(./BetterQuizApp-Results.png) center / cover'}} ></CardTitle>
            </Card> */}


        </div>
      )
    }{/* else if(this.state.activeTab === 3) {
      return (
        <div className="banner-text">
        <h1 style={{textAlign: 'center'}}>MyDog Webpage</h1>
        <hr></hr>
        <div>
        <p>•	Engaged in the use of HTML/CSS.</p>
        <p>•	Focused on crafting visual elements of the website and the greeting generator which allows the user to make greetings.</p>
        <p>•	Created using HTML/CSS, and received a very high grade in the class.</p>
        <div>
        <center>
        <p>URL: <a href = {"https://people.ucsc.edu/~dbuccat/"} rel="noopener noreferrer" target = {"_blank"}> https://people.ucsc.edu/~dbuccat/</a></p>
        </center>
        <div>
        </div>
        <p></p>
        </div>
        </div>
        </div>
      )
    }
*/}
  }



  render() {
    return(
      <div>
        <Tabs activeTab={this.state.activeTab} onChange={(tabId) => this.setState({ activeTab: tabId })} ripple>
          <Tab>Python</Tab>
          <Tab>React</Tab>
          <Tab>Django</Tab>
          {/*<Tab>HTML/CSS</Tab>*/}
        </Tabs>


          <Grid>
            <Cell col={12}>
              <div className="content">{this.toggleCategories()}</div>
            </Cell>
          </Grid>
      </div>
    )
  }
}

export default Projects;
